export default __webpack_public_path__ + "static/media/foc_img.2750c091.png";